import React from 'react';

const Pennsylvania = () => (
  <svg
    width="78"
    height="51"
    viewBox="0 0 78 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.8"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M73.552 8.34016C72.0736 10.6144 71.9187 14.2193 69.9686 16.0218C69.7715 17.6341 71.0457 16.8878 70.9894 18.5847C70.9683 19.2606 69.87 20.2041 69.9686 20.6335C70.2854 22.091 70.912 22.7528 72.0173 23.7034C72.3764 24.0202 72.2074 24.3863 72.5312 24.7243C72.9888 25.2101 73.4816 25.365 74.066 25.7452C74.9671 26.3296 76.0091 27.9913 77.6494 28.3081C77.4664 30.005 76.1147 30.526 75.0868 31.3779C74.1997 32.3637 73.9251 33.976 73.0381 34.9618C72.1651 34.9406 71.7145 35.342 71.5033 35.9827C70.4825 35.9827 69.4547 35.9827 68.4338 35.9827C67.4412 36.7008 66.9132 37.8767 66.3852 39.0525C46.9262 43.1433 27.1293 46.8961 7.51545 50.8249C5.75542 44.0163 3.88981 32.2862 2.3973 23.1753C1.83409 19.7394 0.419022 15.6134 0.862551 13.9588C1.06672 13.1843 1.53136 12.6069 2.3973 11.9099C2.79859 11.586 3.47443 11.7409 3.93204 11.3959C4.90358 10.6707 6.72697 8.10077 8.53628 7.8121C8.69821 9.01609 9.34593 9.73426 9.05024 11.3959C20.7228 9.63568 34.2751 6.89678 46.9333 4.22829C48.1019 3.98186 48.8834 3.44674 50.0028 3.20735C52.0796 2.76378 54.7619 2.72153 57.1696 2.18643C59.697 1.61611 61.6612 0.383964 63.3157 0.651518C64.787 0.883867 65.4559 2.99613 66.8991 2.18643C68.3071 5.05207 69.0041 8.6218 73.552 8.34016Z"
      fill="#FC374D"
    />
  </svg>
);
export default Pennsylvania;
